import { Column, RowData } from '@tanstack/react-table';
import { Button } from '../ui/button';
import { ArrowDownIcon, ArrowUpIcon, CaretSortIcon } from '@radix-ui/react-icons';
import { Link, useLocation, useSearchParams } from 'react-router';
import { Params, SortDirection } from '@/utils/types';
import { mergeQueryParams } from '@/utils/merge-query-params';

type TableHeaderWithSortingProps<T extends RowData> = {
	column: Column<T, unknown>;
	columnName: string;
};

function mergeSortParams(sortBy: string, sortDirection: string, searchParams: URLSearchParams) {
	return mergeQueryParams(searchParams, {
		[Params.sortBy]: sortBy,
		[Params.sortDirection]: sortDirection,
		[Params.page]: 1
	});
}

export const TableHeaderWithSort = <T extends RowData>({ column, columnName }: TableHeaderWithSortingProps<T>) => {
	const location = useLocation();
	const [searchParams] = useSearchParams();

	const getSortIcon = () => {
		if (!column.getIsSorted()) {
			return <CaretSortIcon />;
		}

		return column.getIsSorted() === 'asc' ? <ArrowUpIcon /> : <ArrowDownIcon />;
	};

	const getSortDirection = () => {
		if (!column.getIsSorted()) {
			return SortDirection.ASC;
		}

		return column.getIsSorted() === 'asc' ? SortDirection.DESC : SortDirection.ASC;
	};

	return (
		<Button variant="ghost" onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')} className="p-0">
			<Link
				className="flex items-center"
				to={{
					pathname: location.pathname,
					search: mergeSortParams(column.id, getSortDirection(), searchParams)
				}}
			>
				{columnName}
				{getSortIcon()}
			</Link>
		</Button>
	);
};
